import { Component, HostListener, Injector, OnInit, inject } from '@angular/core';
import { MaterialModule } from 'jk-service';
//import { Stkpi01DetailComponent } from './stkpi01-detail.component';
import { StockView03Component } from '../stock-view03/stock-view03.component';
import { Stkpi01PkgComponent } from './stkpi01Pkg.component';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule } from 'jk-advcom';

@Component({
  selector: 'app-stkpi01',
  templateUrl: './stkpi01.component.html', //templateUrlConfigStk.stkpi01,
  styleUrls: ['./stkpi01.component.scss'],
  standalone: true,
  providers: [],
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    AdvComModule,
    StockView03Component,
  ],
})
export class Stkpi01Component extends Stkpi01PkgComponent implements OnInit {
  override _programId = 'stkpi01';
  constructor() {
    super();
    this.title = '商品基本資料建立'; //###
    this.isCheckPower = false; // ###
    this.gridInitOpt = {
      pageKind: this.pageKind,
      programId: this.programId,
      sortField: 'MA001',
      sort: 'asc',
      defaultSort: null,
    }; // ###
    //this.masterdEditPage = StkmaEditComponent; // ###
    //this.setEntityEvent(this.srv);
    this.addOpenwinLoadOption('STKMA', 'W01', 'W', [], this.stkmaList);

    //this.constructorInit(); // ###
    //this.getLookup(); // ###
  }
  // 以下是自訂
  //stkmaList: any[] = [];
  /*
  @HostListener('window:beforeunload', ['$event']) // FIXME: 重新整理才有用
  async handleBeforeUnload($event: BeforeUnloadEvent) {
    $event.preventDefault();
    let bool = await this.showConfirm(this.title, '確定離開?');
    if (!bool) {
      throw new Error('取消離開.');
    }
    return bool;
  }*/
}

